<template>
  <div class="columns is-multiline">
    <section class="info-tiles column is-12">
      <div class="card">
        <div class="card-header">
          <a @click="toggleInstructions()" class="button is-dark is-radiusless">Ayuda</a>
        </div>
        <form class="has-text-left">
          <div class="card-content">
            <h3 class="is-size-3">{{initTitle}}</h3>
            <br>
            <div class="columns is-multiline">
              <b-field label="Contraseña anterior*" class="column is-12">
                <b-input type="password" v-model="password.before" password-reveal></b-input>
              </b-field>
              <b-field class="column is-6" label="Contraseña nueva*">
                <b-input type="password" v-model="password.new" password-reveal></b-input>
              </b-field>
              <b-field class="column is-6" label="Repetir contraseña nueva*">
                <b-input type="password" v-model="password.rnew" password-reveal></b-input>
              </b-field>
            </div>
          </div>
          <div class="card-footer">
            <button type="button" class="button is-warning is-radiusless" @click="submit()">Enviar</button>
          </div>
        </form>
      </div>
    </section>
    <!-- help -->
    <section v-if="needHelp" class="info-tiles column is-12">
      <div class="card">
        <div class="card-header">
          <a @click="toggleInstructions()" class="button is-light is-radiusless">X Cerrar ayuda</a>
        </div>
        <div class="card-content">
          <h3 class="is-size-3">Ayuda</h3>
          <h3 class="is-size-4">Instrucciones</h3>
          <ul>
              <li>- Campos con (*) son requeridos</li>
            </ul>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import VueCkeditor from 'vue-ckeditor2'
import UsersService from '@/services/UsersService'
import { xMisc } from '@/mixins/xMisc.js'
import { sGate } from '@/mixins/sGate.js'
export default {
  name: 'dashboard',
  mixins: [xMisc, sGate],
  components: {
    VueCkeditor
  },
  data () {
    return {
      password: {
        before: null,
        new: null,
        rnew: null,
        email: this.$session.get('user').user
      },
      needHelp: false,
      helpText: 'Ayuda',
      initTitle: 'Cambiar contraseña'
    }
  },
  mounted () {
  },
  methods: {
    async submit () {
      if (this.password.before == null) {
        this.alert('danger', 'Contraseña anterior es requerida')
        return false
      }
      if (this.password.new == null) {
        this.alert('danger', 'Contraseña nueva es requerida')
        return false
      }
      if (this.password.rnew == null) {
        this.alert('danger', 'Repetir contraseña nueva es requerida')
        return false
      }

      if (this.password.new !== this.password.rnew) {
        this.alert('danger', 'Contraseña nueva no coincide con repetir contraseña')
        return false
      }

      var response = {}

      response = await UsersService.changePassword({data: this.password}, this.$session.get('user').token)

      if (response.data.success) {
        this.$toast.open({
          message: 'Contraseña actualizada',
          type: 'is-success'
        })
        this.goTo('home')
      } else {
        this.alert('danger', 'Error, no se pudo actualizar la contraseña')
      }
    },
    toggleInstructions () {
      if (this.needHelp) {
        this.needHelp = false
        this.helpText = 'Ayuda'
      } else {
        this.needHelp = true
        this.helpText = 'Cerrar ayuda'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/ChangePassword.vue